module.exports = __webpack_public_path__ + "img/BE0822008979.9bd824c4.svg";